const MOBILE_WIDTH = 800;
const SMALL_MOBILE_WIDTH = 400;
const ORDER_TIME_LIMIT = 1.1 * 360 * 24 * 3600000; // one year

export { MOBILE_WIDTH, SMALL_MOBILE_WIDTH, ORDER_TIME_LIMIT };
